import { Edit } from "react-admin";
import { BankForm } from "./Form";

export function PayerBankEdit() {
  return (
    <Edit mutationMode="pessimistic" redirect="list">
      <BankForm />
    </Edit>
  );
}
